"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const translation_1 = require("../../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../../common/js/stores/AuthorizationStore"));
const MachineStore_1 = __importDefault(require("../../stores/MachineStore"));
const CutterTile_1 = __importDefault(require("./CutterTile"));
class CutterSlider extends react_1.default.Component {
    contextReactionDisposer;
    currentCutterIndex = 0;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            currentCutterIndex: mobx_1.observable,
            cutters: mobx_1.computed,
            buttonLeftDisabled: mobx_1.computed,
            buttonRightDisabled: mobx_1.computed,
            onClickButtonLeft: mobx_1.action.bound,
            onClickButtonRight: mobx_1.action.bound,
        });
    }
    get cutters() {
        return MachineStore_1.default.cutters;
    }
    get buttonLeftDisabled() {
        return this.currentCutterIndex <= 0;
    }
    get buttonRightDisabled() {
        return this.currentCutterIndex + 1 >= MachineStore_1.default.cutters.length;
    }
    componentDidMount() {
        this.contextReactionDisposer = (0, mobx_1.reaction)(() => AuthorizationStore_1.default.customerId, () => MachineStore_1.default.readMassiveMachines(), { fireImmediately: true });
    }
    componentWillUnmount() {
        this.contextReactionDisposer?.();
    }
    render() {
        if (MachineStore_1.default.isLoading) {
            return react_1.default.createElement(LoadingSpinner_1.default, { center: true });
        }
        return (react_1.default.createElement("section", { className: "znd-cutter-slider" },
            react_1.default.createElement("div", { className: "znd-cutter-slider__title t-body-tiny" }, (0, translation_1.t)('cutters.title')),
            0 === this.cutters.length ? (react_1.default.createElement("section", { className: "znd-dashboard-cutter-info-text" },
                react_1.default.createElement("div", { className: "znd-dashboard-cutter-info-text__text" }, (0, translation_1.t)('dashboard.cutter.no_cutters')))) : (react_1.default.createElement(CutterTile_1.default, { cutter: this.cutters[this.currentCutterIndex], onClickButtonLeft: this.onClickButtonLeft, onClickButtonRight: this.onClickButtonRight, buttonLeftDisabled: this.buttonLeftDisabled, buttonRightDisabled: this.buttonRightDisabled }))));
    }
    onClickButtonLeft() {
        this.currentCutterIndex--;
    }
    onClickButtonRight() {
        this.currentCutterIndex++;
    }
}
exports.default = (0, mobx_react_1.observer)(CutterSlider);
